import React, { useEffect, useState } from "react";

import "../../assets/css/styles.css";
import "../../assets/libs/bootstrap/css/bootstrap.min.css";
import Image from "../../assets/images/faces/4.jpg";
import noData from "../../assets/images/no-data.png";
const Recent = ({ data }) => {
  const [languageData, setLanguageData] = useState(null);
  const [formattedDate, setFormattedDate] = useState("");

  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      import(`../../lang/dashboard/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }

    /*     if (data?.messages?.length > 0) {
      const rawDate = data.messages[0].date;

      const [month, day, year, hour, minute] = rawDate.split(/[-\s:]/);
      const dateTime = new Date(`${year}-${month}-${day}T${hour}:${minute}:00`);

      const formattedDate = new Intl.DateTimeFormat(
        cookieLang === "fr" ? "fr-FR" : "en-US",
        {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        }
      ).format(dateTime);

      const finalDate =
        cookieLang === "en" ? formattedDate.replace(/\//g, "-") : formattedDate;

      setFormattedDate(finalDate);
    } */
  }, []);

  if (!languageData) {
    return <div></div>;
  }

  return (
    <div className="col-xl-6 text-left">
      <div className="card custom-card">
        <div className="card-header d-flex justify-content-between">
          <div className="flex-1">
            <div className="card-title">{languageData.messages.title}</div>
          </div>
          <div className="dropdown">
            <a
              data-interaction="view_all_messages_button"
              href="/portal/messages"
              className="btn-outline-light btn btn-sm text-muted"
            >
              {languageData.messages.view_all}
            </a>
          </div>
        </div>
        <div className="card-body">
          {data.messages?.length > 0 ? (
            <ul className="list-unstyled mb-0 flex flex-column gap-3">
              {data.messages.map((msg) => {
                const date = new Date(msg.date);

                const formattedDate =
                  `${date.getUTCFullYear()}-` +
                  `${String(date.getUTCMonth() + 1).padStart(2, "0")}-` +
                  `${String(date.getUTCDate()).padStart(2, "0")} ` +
                  `${String(date.getUTCHours()).padStart(2, "0")}:` +
                  `${String(date.getUTCMinutes()).padStart(2, "0")}`;

                return (
                  <li key={msg.id} className="list-item">
                    <div className="d-flex align-items-start">
                      <img
                        src={msg.expert?.image}
                        alt={msg.expert?.nickname}
                        className="avatar rounded-circle me-3"
                      />
                      <div className="flex-1">
                        <div className="flex align-items-center justify-content-between">
                          <p className="mb-0 fw-semibold fs-15">
                            {msg.expert?.nickname}
                          </p>
                          <span className="fs-14 text-muted">
                            {formattedDate}
                          </span>
                        </div>

                        <div className="flex justify-content-between">
                          <span className="fs-14 text-muted">
                            {msg.last_message}
                          </span>
                        </div>
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          ) : (
            <span class="mb-0 fs-18 font-15">⚊ </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default Recent;
